import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';

export default class TipoServicoValidation extends DefaultValidation{

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs) {
        let validated = true;
        let tiposervico = model;

        if ( !tiposervico.descricao || !tiposervico.descricao.trim() ) {
            refs.titleInput.focusedOut = true;
            validated = false;
        }
        // if ( !tiposervico.cor ) {
        //     refs.cpInput.$el.classList.add('mandatory');
        //     validated = false;
        // }
        if ( !validated ){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios', true));
        }
        
        return validated;
    }

}